export default __webpack_public_path__ + "56f452eaa36e59745252064f60c8f2a9.svg";